import { Stack, Typography, Box, Button, Paper, Divider } from "@mui/material";
import { LoadingButton } from "@mui/lab";

function formatMoney(amount, currency = "INR") {
  const symbol = currency === "INR" ? "₹" : "$";
  return `${symbol}${Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

const Row = ({ label, value, bold = false }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
    <Typography
      variant="body2"
      color={bold ? "text.primary" : "text.secondary"}
      fontWeight={bold ? 600 : 400}
    >
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={bold ? 600 : 400}>
      {value}
    </Typography>
  </Box>
);

// plan here is the payload produced by PlanSelectionStep:
// { line_items: [{ label, unit_price, quantity, line_total }], total_cost, currency, duration }
//
// line_items is expected to be an array, but some callers send a single
// object instead (as seen from PlanSelectionStep). Normalize here so this
// component works either way instead of throwing on .map().
export default function ReviewStep({ account, plan, onBack, onConfirm, isSubmitting }) {
  const billingLabel = plan.duration === "Y" ? "/year" : plan.duration === "M" ? "/month" : " one-time";

  const lineItems = Array.isArray(plan.line_items)
    ? plan.line_items
    : plan.line_items
    ? [plan.line_items]
    : [];

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h6" fontWeight={600}>
          Review &amp; Pay
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Confirm your details before you pay.
        </Typography>
      </Box>

      {account && (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
            Review Your Account
          </Typography>
          <Row label="Name" value={account.name} />
          <Row label="Email" value={account.email} />
          {account.company && <Row label="Company" value={account.company} />}
        </Paper>
      )}

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
          Your Chargers
        </Typography>
        {lineItems.map((item, index) => (
          <Row
            key={item.id ?? index}
            label={`${item.label} (${item.quantity})`}
            value={formatMoney(item.line_total, plan.currency)}
          />
        ))}
        <Divider sx={{ my: 1.5 }} />
        <Row
          label="Total"
          value={`${formatMoney(plan.total_cost, plan.currency)}${billingLabel}`}
          bold
        />
      </Paper>

      <Stack direction="row" justifyContent="space-between">
        <Button onClick={onBack} sx={{ color: "text.secondary" }}>
          Back
        </Button>
        <LoadingButton variant="contained" loading={isSubmitting} onClick={onConfirm}>
          Continue to Payment
        </LoadingButton>
      </Stack>
    </Stack>
  );
}